import { z } from '@/lib/zod'

export const FilterGenericContentSchema = () => {
  return z.object({
    freeSearch: z.string().optional().nullable(),
    contentType: z.string().optional().nullable(),
    relativeKeys: z.string().optional().nullable(),
    searchTags: z.string().optional().nullable(),
    isActive: z.boolean().nullable().optional().default(false),
  })
}

export type FilterGenericContentForm = z.infer<
  ReturnType<typeof FilterGenericContentSchema>
>
